import React, {useCallback, useState} from 'react';
import Modal from 'pages/components/Modal/Modal';
import CustomButton from 'pages/components/CustomButton/CustomButton';
import styles from './RentADronePage.module.css';
import ConnectForm from './ConnectForm';
import ImageCollage from './ImageCollage';

// Constants moved outside component to prevent recreation
const USE_CASES_DATA = [
  { 
    id: 'aerial-photography',
    label: "Aerial Photography", 
    imageUrl: '/Assets/Images/RentADrone/Drone_arial.png' 
  },
  { 
    id: 'surveys',
    label: "Surveys", 
    imageUrl: '/Assets/Images/RentADrone/Drone_survey.png' 
  },
  { 
    id: 'surveillance',
    label: "Surveillance", 
    imageUrl: '/Assets/Images/RentADrone/Drone_surveilance.png' 
  },
  { 
    id: 'agriculture',
    label: "Agriculture", 
    imageUrl: '/Assets/Images/RentADrone/Drone_agriculture.png' 
  }
];

// Memoized component for use case items
const UseCaseItem = React.memo(({ useCase }) => (
  <div className={styles.useCaseItem}>
    <img 
      src={useCase.imageUrl} 
      alt={useCase.label}
      loading="lazy"
    />
    <p>{useCase.label}</p>
  </div>
));

const RentADronePage = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const handleOpenQuoteModal = useCallback(() => setIsQuoteModalOpen(true), []);
  const handleCloseQuoteModal = useCallback(() => setIsQuoteModalOpen(false), []);
  return (
    <div className={styles.rentDronePage}>
      <header>
        <h2>Rent a Drone</h2>
        <p>Fly now. Own later</p>
      </header>
      
      <ImageCollage />
      
      <div style={{marginTop:'-60px'}}>
        <p>
          axldrone's Rent a Drone program gives you access to professional-grade drones when you need them without the cost or commitment of ownership. Whether you're capturing stunning aerial footage, conducting site inspections, spraying agricultural fields or testing before you buy, our fleet is ready for your mission. Flexible plans. Hassle-free rentals. Fly smarter with axldrone.
        </p>
      </div>
      
      <div className={styles.useCasesContainer}>
        {USE_CASES_DATA.map((useCase) => (
          <UseCaseItem key={useCase.id} useCase={useCase} />
        ))}
      </div>
      
      <div className={styles.noOwnership}>
        <h3>No ownership. No barriers. Just lift-off.</h3>
        <p>axldrone's Rent a Drone program is more than a rental service—it's a launchpad for a future-proof career.</p>
        <p>Drones are transforming industries—from real estate and construction to agriculture, logistics, and filmmaking. Our program gives you access to cutting-edge drone technology without the high upfront costs, so you can start offering services, build your portfolio, and earn income from day one.</p>
        <p>Whether you're looking to start a full-time drone career, build a freelance side hustle, or transition out of unemployment, this is your chance to gain hands-on experience with pro-grade equipment, learn on the job, and take advantage of a fast-growing market with endless opportunities.</p>
        <p>Turn your free time into paid gigs by offering drone services for real estate, agriculture, inspections, or events. Build your skills, explore your passion for aerial photography, or test the waters of a drone-based business. With professional-grade drones available when you need them, axldrone empowers you to fly toward financial freedom, one mission at a time.</p>
        <p>From passion to profession—axldrone helps you turn flight into a future.</p>
      </div>

              {/* Quote Button */}
              <section className={styles.quoteSection}>
          <CustomButton
            onClick={handleOpenQuoteModal}
            size="large"
            ariaLabel="Let's connect"
            icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>}
          >
            Let's connect
          </CustomButton>
        </section>

        {/* Quote Modal */}
        <Modal isOpen={isQuoteModalOpen} onClose={handleCloseQuoteModal} title="Let's connect" maxWidth="40rem">
        <ConnectForm />
        </Modal>
      

    </div>
  );
};

export default RentADronePage;